var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.7503H22.6667M11.3333 18.417H19.8333M25.5 5.66699C26.6272 5.66699 27.7082 6.11476 28.5052 6.91179C29.3022 7.70882 29.75 8.78982 29.75 9.91699V21.2503C29.75 22.3775 29.3022 23.4585 28.5052 24.2555C27.7082 25.0526 26.6272 25.5003 25.5 25.5003H18.4167L11.3333 29.7503V25.5003H8.5C7.37283 25.5003 6.29183 25.0526 5.4948 24.2555C4.69777 23.4585 4.25 22.3775 4.25 21.2503V9.91699C4.25 8.78982 4.69777 7.70882 5.4948 6.91179C6.29183 6.11476 7.37283 5.66699 8.5 5.66699H25.5Z",
    stroke: "#0051A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c75dcdabd5d1346b1f082f655810050f.svg";
export { ForwardRef as ReactComponent };